export default __webpack_public_path__ + "static/media/document-social-icon.7e0a022a.svg";